import styled from '@emotion/styled'
import Drawer from 'rc-drawer'

const StyledDrawer = styled(Drawer)`
  background: rgba(16, 25, 36, 0.4);
  position: ${({ open }) => {
    return open ? 'fixed' : 'static'
  }};
  overflow: hidden;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  .drawer-content-wrapper {
    float: ${({ placement }) => {
      return placement || 'right'
    }};
    background: #fff;
    height: 100%;
  }
  .drawer-content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }
`

export default StyledDrawer
